<ds-paper id="notesWidgetPaper" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_L" elevation="elevation_none"
  insidePaddingBottom="bottom-spacing_L" insidePaddingLeft="left-spacing_XL" insidePaddingRight="right-spacing_XL">
  <div id="sectionTitle" class="section-title">
    <typography id="widgetTitle" variant="mat-headline-6" weight="bold">
      {{appStrings.notesWidget_title}}
    </typography>
  </div>
  <ds-divider></ds-divider>
  <form id="main-form" [formGroup]="formNotes">
    <div id="notes">
      <div id="notesArea" class="notes-area">
        <ds-multiline id="notesInput" label_orientation="vertical-label" placeholder="{{appStrings.notesWidget_label}}"
        maxLength="2000" [control]="formNotes.controls.notes" class="fill-width"></ds-multiline>
        <ds-button [isDisabled]="!formNotes.controls.notes.value" type="secondary" id="add-note" (onClick)="addNote()"
          label="{{appStrings.notesWidget_addNote}}" size="medium" variant="label-only" class="add-note-btn">
        </ds-button>
      </div>

      <ds-divider></ds-divider>
      <div id="notesContainer" class="notes-container">
        @for (note of notesData; track note; let i = $index) {
          <ds-paper id="notePaper_{{i}}" borderRadius="radius_XS" outline="outlined"
            insidePaddingTop="top-spacing_M" insidePaddingBottom="bottom-spacing_M" insidePaddingLeft="left-spacing_M"
            insidePaddingRight="right-spacing_M">
            <div id="noteContainer_{{i}}" class="note-container">
              <div id="noteContent_{{i}}" class="note-content">
                <div class="note-header">
                  <typography id="noteDate_{{i}}" variant="mat-caption-1" weight="bold">
                    {{note.author}} - {{ note.noteDate | date:dateTimeFormat }}
                  </typography>
                  @if (isTouchpointNote(note)) {
                    @if (canOpenTouchpoint(note)) {
                      <button type="button" id="touchpointChip_{{i}}" class="touchpoint-chip-trigger"
                        [attr.aria-label]="appStrings.label_touchpointNote" (click)="openTouchpoint.emit(note)">
                        <ng-container *ngTemplateOutlet="touchpointChip; context: { $implicit: note }"></ng-container>
                      </button>
                    } @else {
                      <ng-container *ngTemplateOutlet="touchpointChip; context: { $implicit: note }"></ng-container>
                    }
                  }
                </div>
                <typography variant="mat-body-2" weight="regular" id="notesContent_{{i}}" class="note-text">
                  {{ note.noteText }}
                </typography>
              </div>
              @if (!note.isPermanent) {
                <div id="deleteButtonContainer_{{i}}">
                  <ds-button variant="icon-only" icon="delete" (onClick)="deleteNote(i)" size="medium" id="deleteNote_{{i}}"
                    type="tertiary" iconStyle="material-icons-outlined">
                  </ds-button>
                </div>
              }
            </div>
          </ds-paper>
        }
      </div>
    </div>
  </form>
</ds-paper>

<ng-template #touchpointChip let-note>
  <ds-chip variant="outline" size="small">{{ getTouchpointChipLabel(note) }}</ds-chip>
</ng-template>

<ds-dialog
  id="deleteConfirmationDialog"
  [title]="appStrings.noteWidget_deleteMessageTitle"
  [description]="appStrings.notesWidget_confirmationNoteDeleteQuestion"
  [actionButtons]="deleteConfirmationButtons"
  [open]="deleteConfirmationOpen$">
</ds-dialog>